module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc10-e9068634c89d75b3a14356d318a5b8b2.jpg";